export const PhotoCenterMode = Object.freeze({
  lightbox: 'lightbox',
  photoEditor: 'photo-editor'
});
